import React, { useEffect, useContext, useState } from 'react';

import CircleLoader from 'ggApp/shared/components/CircleLoader';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';
import { CHECKOUT_STEP_NAMES } from 'ggApp/modules/newCheckout/constants';

import CheckoutStep from '../CheckoutStep';
import ProgressBar from './ProgressBar';

import { Container } from './styles';

export const CheckoutSteps = ({ flow, nethone, closeCheckout }) => {
    const { current, orderNumber, send } = useContext(OrderContext);
    const [activeStep, setActiveStep] = useState(null);

    useEffect(() => {
        const findStep = flow().steps.find((i) => current.matches(i.name));

        if (findStep) {
            setActiveStep(findStep);
        }
    }, [current, flow]);

    if (current.matches('loadingOrder') || !orderNumber) return <CircleLoader />;

    const showProgress = ![CHECKOUT_STEP_NAMES.ORDER_ERROR, CHECKOUT_STEP_NAMES.TWOFA_HELP].some(
        current.matches,
    );

    return (
        <Container className="checkoutProvider" showProgress={showProgress}>
            {showProgress && (
                <ProgressBar
                    numberOfSteps={[...new Set(flow().steps.map((i) => i.stepIndex))].length}
                    stepIndex={activeStep?.stepIndex ?? 0}
                />
            )}

            {activeStep && (
                <CheckoutStep
                    flowName={flow().name}
                    flowPayload={flow()}
                    stepperPayload={activeStep}
                    componentProps={activeStep}
                    component={activeStep.component}
                    orderNumber={orderNumber}
                    closeCheckout={closeCheckout}
                    nethone={nethone}
                    send={send}
                    current={current}
                />
            )}
        </Container>
    );
};

export { CheckoutSteps as CheckoutStepsProvider };
